import './DotGrid.css';

const DotGrid = ({ className = '' }) => {
  return <div className={`dot-grid-bg ${className}`} />;
};

export default DotGrid;
